import ReactGA from 'react-ga4';

export default function useGoogleAnalytics() {
	if (!window.location.host.includes('localhost:')) {
		ReactGA.initialize('G-VP6P6TPKBE');
		// ReactGA.pageview(window.location.pathname + window.location.search);
		// Send pageview with a custom path
		ReactGA.send({
			hitType: 'pageview',
			page: window.location.pathname + window.location.search,
		});
	}
	return null;
}
